import { reactive } from 'vue'

export const store = reactive({
  account: null,
  session: null,
  userMetadata: null /* datelier customer data, not stytch */
})
